module.exports = __webpack_public_path__ + "img/00025.cda89024.webp";